import {State} from '../types'

export const isTemplate = (state: State) => state.instance.siteIsTemplate
